"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _UploadItem = _interopRequireDefault(require("./UploadItem"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// COMPONENTS

var createCompositeFileKey = function createCompositeFileKey(file) {
  return "".concat(file.name, "-").concat(file.size, "-").concat(file.lastModified);
};
var UploadList = function UploadList(_ref) {
  var fileList = _ref.fileList,
    onDownload = _ref.onDownload,
    onRemove = _ref.onRemove,
    _ref$ItemComponent = _ref.ItemComponent,
    ItemComponent = _ref$ItemComponent === void 0 ? _UploadItem.default : _ref$ItemComponent;
  if (!fileList) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, fileList.map(function (file) {
    return /*#__PURE__*/_react.default.createElement(ItemComponent, {
      file: file,
      key: createCompositeFileKey(file),
      onDownload: onDownload,
      onRemove: onRemove
    });
  }));
};
var _default = UploadList;
exports.default = _default;